module.exports = __webpack_public_path__ + "static/media/1POLICY40.2c932891.jpg";